import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'AuthService';
import { Injectable } from '@angular/core';

@Injectable()
export class ExternGuard  {

  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isSelbstauskunftEnabled = this.authService.isSelbstauskunftEnabled();
    const currentPath = state.url.split(/[?#]/, 1)[0];
    const isProfilRoute = currentPath === '/extern/profil';
    const isSelbstauskunftRoute = currentPath === '/extern/selbstauskunft';

    if (!isSelbstauskunftEnabled && isSelbstauskunftRoute) {
      this.router.navigate(['/extern/home']);
      return false;
    }

    if (this.authService.isNew() && !isProfilRoute && !isSelbstauskunftRoute) {
      this.router.navigate(['/extern/profil']);
      return false;
    }
    else if (isSelbstauskunftEnabled && !this.authService.isFreigegeben() && !isSelbstauskunftRoute && !isProfilRoute) {
      this.router.navigate(['/extern/selbstauskunft']);
      return false;
    }

    return true;
  }
}
